export default function isFullName(values, value) {
  if (value && value.length) {
    const names = value.trim().split(/ +/g);
    return names.length >= 2;
  }

  return true;
}
